import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const triggerForecast = {
  name: "triggerForecast" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.object({
    success: z.boolean(),
    workflowId: z.string().nullable(),
    error: z.string().nullable(),
  }),
};
